((Drupal) => {
  Drupal.behaviors.heroSlide = {
    attach: function (context, settings) {
      let hero_slide = document.querySelectorAll('.paragraph--type--hero .swiper-wrapper');
      Array.from(hero_slide).forEach(function (hero_slide) {
        if (hero_slide.children.length <= 1) {
          return;
        }

        let slides = hero_slide.querySelectorAll('.paragraph--type--hero-slide .swiper-buttons');
        Array.from(slides).forEach(function (swiper_buttons) {
          swiper_buttons.style.display = null;
        });
      });
    }
  }
})(Drupal);
